import React, { useState, useEffect } from "react";

const useAudio = url => {
  const [audio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
    audio.volume = 1
      playing ? audio.play() : audio.pause();
    },
    [playing, audio]
  );

  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, [audio]);

  return [playing, toggle];
};

const Player = ({ url, tagId }) => {
  const [playing, toggle] = useAudio(url);

  return (
    <div style={{ display: 'none' }}>
      <button id={tagId || 'notify'} onClick={toggle}>{playing ? "Pause" : "Play"}</button>
    </div>
  );
};

export default Player;